const styles = {
  root: {
    backgroundColor: 'background.white',
    width: '100%',
    marginBottom: 4,
  },

  description: {
    marginTop: 1,
    '&.v1': {
      color: 'common.black',
      lineHeight: '16px !important',
      fontSize: '14px !important',
    },
  },
  withBorder: {
    backgroundColor: 'background.default',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'background.border',
    borderRadius: 1,
    p: 2,
  },
  contentBtn: {
    // fontSize: 12,
    // margin: 0,
    backgroundColor: 'text.white',
    // color: 'text.primaryDark',
    border: '1px solid rgba(0,0,0,0.2)',
    marginBottom: 1,
    '&:hover': {
      border: '1px solid rgba(0,0,0,0.2)',
    },
    '&.featured': {
      backgroundColor: '#8C46ED',
    },
    lineHeight: '18px !important',
    '& .MuiTypography-root': {
      color: 'text.white',
    },
  },
  contactContainer: {
    backgroundColor: 'none',
    '& div div a, button': {
      fontWeight: '500',
    },
  },
  contactInfo: {
    '&.v1': {
      fontSize: '12px !important',
      lineHeight: '14px !important',
      color: 'text.grey300',
    },
  },
}

export default styles
